import React from 'react'

const LeadManagement = () => {
    return (
        <div>LeadManagement</div>
    )
}

export default LeadManagement